import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import VideoDemos from "./VideoDemos";
import MasterInfo from "../Common/InfoMaster";
import SiteMap from "../Common/SiteMap";
import { appName } from "../Common/Constants";
import { useLocation, useNavigate } from "react-router-dom"

interface listItemProps {
  title: string;
    content: string;

}
interface searchItemProps {
    title: string;
    content: string;
    link: string,
    route: string,
    group:string

}
interface  infoProps {
    category: string;

}
const ListItem = (props: listItemProps) => {
  return (
    <div style={{ marginTop: "20px" }}>
      <p style={{ fontWeight: "bold" }}>{props.title}</p>
      <p>{props.content}</p>
    </div>
  );
};
const SearchItem = (props: searchItemProps) => {
    const navigate = useNavigate();
    let link: any = "";
    const openRoute = (route:string) => {
        navigate("/" + route)
    }
    if (props.group == appName) {
        return (<span onClick={()=>openRoute(props.route) }>Click To Open {props.title}</span>)
    }
    else {
        return (<a href={props.link}> Click To Open { props.title}</a>)
    }
    return (
        <div style={{ marginTop: "20px" }}>
            <p style={{ fontWeight: "bold" }}>{props.title}</p>
            <p>{props.content}</p>
            <p>{link}</p>
        </div>
    );
};
const Information = (props:infoProps) => {
    const [selected, setSelected] = useState(0);
    const [category, updateCategory] = useState("");

    useEffect(() => {
        if (props.category != null) { updateCategory(props.category) }
    }, [props.category])

  const handleSelect = (e: any) => {
    setSelected(e.selected);
    };

    


    const createFaq = () => {
        return ( <TabStripTab title="FAQ">
            { MasterInfo.filter(item => item.type === "faq" && (item.categorys.indexOf(category)>-1 || category==""))
                .map((faqItem, index) => (
                    <ListItem
                        key={index} 
                        title={faqItem.title}
                        content={faqItem.content}
                    />
                )
            )}
        </TabStripTab>)
    }
    const createDefinition= () => {
        return (<TabStripTab title="Definitions">
            {MasterInfo.filter(item => item.type === "definition" && (item.categorys.indexOf(category) > -1 || category == ""))
                .map((faqItem, index) => (
                    <ListItem
                        key={index}
                        title={faqItem.title}
                        content={faqItem.content}
                    />
                )
                )}
        </TabStripTab>)
    }
  return (
    <TabStrip
      selected={selected}
      onSelect={handleSelect}
      style={{ maxHeight: "500px" }}
    >
          {createFaq()}
         
              {createDefinition()}

      <TabStripTab title="Video Demos">
        <div>
          <VideoDemos />
        </div>
      </TabStripTab>
    </TabStrip>
  );
};

export default Information;
